import {
    name,
    apiVersion,
    version
} from '../../package.json'
export const APP_NAME = name
// 版本号每个版本记得在package.json中修改
export const API_VERSION = apiVersion
export const APP_VERSION = version
export const API_HOST = {
    alpha: '//192.168.1.207/icar_dev3/h5_marketing.php',
    // beta: '//test.carisok.com/icar_beta03/h5_marketing.php',
    beta: '//test.carisok.com/icar_beta02/h5_marketing.php',
    abtest: '//abtest-api.carisok.com/h5_marketing.php',
    release: '//api.carisok.com/h5_marketing.php',
}
